export enum ErrorMessages {
  LOGIN_ERROR = 'Your email and password combination does not match a TapSpots account. Please try again or retrieve your password below.',
  FORGOT_PASSWORD = "We don't recognize this email, please enter a email that is in use",
  PROFILE_INFO = 'Failed to update profile, image you uploaded is unsupported or the profile info you entered is already taken',
  TOKEN = 'Token has expired',
  OLD_PASSWORD = "Old password isn't valid",
  DASHBOARD_DATA = 'Failed to load dashboard data',
  BEER_STYLE_UPDATE = 'Failed to update beer style',
  BEER_STYLE_CREATE = 'Failed to create beer style',
  BREWERIES = 'Failed to get breweries',
  BREWERY_BEERS = 'Failed to get brewery beers',
  CREATE_BREWERY = 'Failed to create new brewery, check your inputs and try again',
  BREWERY_UPDATE = 'BREWERY_UPDATE',
  DATA = 'Failed to get data',
  PAGE_EDITOR_DELETE = 'Failed to delete page editor',
  PAGE_EDITOR_UPDATE = 'Failed to update editor, check your inputs and try again',
  PUB_UPDATE = 'Failed to update pub',
  PUB_CREATE = 'Failed to create new pub, check your inputs and try again',
  UPDATE_USER = 'Failed to update user, check your inputs and try again',
  UNASSIGN_EDITOR = 'Failed to unassign editor',
  MANAGED_PUB = 'Failed to get managed pub data',
  CREATE_POST = 'Failed to create post',
  GET_PUB_POSTS = 'Failed to get pub posts',
  UPDATE_POST = 'Failed to update post',
}
